import { cn } from "@/libs/utils";
import React from "react";

export default function SectionHeader({
  children,
  className = "",
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "text-3xl text-center laptop:text-start laptop:py-6 font-400",
        className
      )}
    >
      {children}
    </div>
  );
}
